<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';
import appConfig from "@/app.config";

import InvoiceService from '@/services/invoice'

moment.locale('pt-BR');

export default {
  page: {
    title: "Histórico de Comissão",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, DatePicker },
  data() {
    return {
      title: "Histórico de Comissão",
      loading: false,
      commissions: [],
      searchParams: {
        startDate: '',
        endDate: '',
      },
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      totalInvoices: 0,
      totalProducts: 0,
      totalCommissions: 0,

      fields: [
        { key: 'invoice', sortable: true, label: 'Origem', formatter: (value, index, item) => {
          if (item.invoice) {
            if (item.invoice.attendanceCode === 5) {
              return 'APP'
            }

            if (item.invoice.attendanceCode === 6) {
              return 'WEB'
            }

            return 'MOB';
          }

          return '';
        } },
        { key: 'paymentDate', sortable: true, label: 'Data', formatter: (value) => {
          return moment(value).format('DD/MM/YYYY');
        } },
        { key: 'invoice.number', sortable: true, label: 'Número NF', formatter: (value, index, item) => {
          return `${item.invoice.number}-${item.invoice.series}`;
        } },
        { key: 'sellerName', sortable: true, label: 'Vendedor' },
        { key: 'customerName', sortable: true, label: 'Cliente' },
        { key: 'paymentConditionDescription', sortable: true, label: 'Condição Pagto' },
        { key: 'invoice.totalValue', sortable: true, label: 'R$ Valor NF', formatter: (value) => {
          return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'invoice.productsValue', sortable: true, label: 'R$ Valor Produtos', formatter: (value, index, item) => {
          return (value - item.invoice.discountValue).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'installment', sortable: true, label: 'Parcela' },
        { key: 'paymentValue', sortable: true, label: 'R$ Valor Pago', formatter: (value) => {
          return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'calculatedCommission', sortable: true, label: 'R$ Valor Comissão', formatter: (value) => {
          return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
      ],
    };
  },
  mounted() {
    const now = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);

    this.searchParams.startDate = startDate;
    this.searchParams.endDate = now;

    this.search();
  },
  methods: {
    search() {
      this.loadCommissions();
    },
    loadCommissions(page = 1, showLoading = true) {
      if (showLoading) {
        this.loading = true;
      }

      if (!this.searchParams.startDate) {
        if (!this.searchParams.endDate) {
          this.searchParams.endDate = new Date();
        }
        
        const startDate = new Date(this.searchParams.endDate);
        startDate.setDate(startDate.getDate() - 7);
        this.searchParams.startDate = startDate;
      }

      if (!this.searchParams.endDate) {
        this.searchParams.endDate = new Date();
      }

      this.searchParams.page = page;

      InvoiceService.getCommissions(this.searchParams)
        .then(res => {
          this.loading = false;

          this.commissions = res.data.commissions;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;

          this.totalInvoices = res.data.totalInvoices;
          this.totalProducts = res.data.totalProducts;
          this.totalCommissions = res.data.totalCommissions;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadCommissions(this.currentPage);
    },
    exportData() {
      this.loading = true;

      InvoiceService.exportCommissions(this.searchParams).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'HistoricoComissao.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    },
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group mb-3">
                        <label>Período de</label>
                        <date-picker v-model="searchParams.startDate" :first-day-of-week="1" format="DD/MM/YYYY" lang="pt-br"></date-picker>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-group mb-3">
                        <label>até</label>
                        <date-picker v-model="searchParams.endDate" :first-day-of-week="1" format="DD/MM/YYYY" lang="pt-br"></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="commissions"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template slot="bottom-row">
                  <td colspan="4" class="border-0 text-right"></td>
                  <td class="border-0 text-left">
                    <strong>Valor Total:</strong>
                  </td>
                  <td class="border-0 text-left nowrap-col">
                    <h4 class="m-0">R$ {{totalInvoices | currency}}</h4>
                  </td>
                  <td class="border-0 text-left nowrap-col">
                    <h4 class="m-0">R$ {{totalProducts | currency}}</h4>
                  </td>
                  <td colspan="2" class="border-0 text-right"></td>
                  <td class="border-0 text-left nowrap-col">
                    <h4 class="m-0">R$ {{totalCommissions | currency}}</h4>
                  </td>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>


<style lang="scss">
  .button-search {
    display: flex;
    align-items: center;
  }

  .nowrap-col {
    white-space: nowrap;
  }
</style>